import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-cgv',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterLink],
  templateUrl: './cgv.component.html',
  styleUrl: './cgv.component.scss'
})
export class CgvComponent implements OnInit {
  title = 'Conditions Générales de Vente';
  subtitle = 'Conditions applicables aux services de courtage en assurance proposés par Brokins';
  heroImage = 'assets/static_pages_images/notre-approche.jpg';
  breadcrumbs = [
    { label: 'Legal', url: undefined },
    { label: 'CGV', url: undefined }
  ];
  prevPage = {
    title: 'Politique de Confidentialité',
    link: '/politique-confidentialite'
  };
  nextPage = undefined; // Last page

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToContact(): void {
    this.router.navigate(['/contact']);
  }
}
